<template>
  <transition name="toast-slide">
    <div v-if="message" class="message-toast fixed top-3 right-3 z-50 w-[280px] max-w-[calc(100%-1.5rem)] cursor-pointer select-none"
         role="alert" @click="$emit('click')">
      <div class="flex items-start gap-2 rounded-xl bg-[rgba(156,186,252,0.3)] border border-[#9CBAFC] text-black shadow-lg px-3 py-2.5">
        <i class="ri-chat-3-line text-brand text-lg leading-none mt-0.5" />
        <div class="min-w-0 flex-grow">
          <div class="text-sm font-semibold leading-tight truncate">{{ message.title }}</div>
          <div v-if="message.preview" class="toast-preview text-xs leading-snug opacity-90 mt-0.5">{{ message.preview }}</div>
        </div>
        <button type="button" class="ml-1 -mr-1 -mt-0.5 text-black/60 hover:text-black text-base leading-none"
                :aria-label="$t('common.dismiss')" @click.stop="$emit('close')">
          <i class="ri-close-line" />
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  /* Clamp the preview to two lines without depending on the line-clamp Tailwind plugin. */
  .toast-preview {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .toast-slide-enter-active,
  .toast-slide-leave-active {
    transition: opacity .25s ease, transform .25s ease;
  }
  .toast-slide-enter-from,
  .toast-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
</style>

<script>
export default {
  name: 'MessageToast',
  props: {
    // The toast payload: { title: String, preview: String }. When null, nothing renders.
    message: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ['close', 'click'],
}
</script>
